<template>
  <div>
     <sequencing-navbar @saveSequence="saveSequence" :isDirty=isDirty></sequencing-navbar>
    <sequencing
      ref="sequencingComponent"
      v-if="space"
      class="content-wrapper border border-solid d-theme-border-grey-light rounded relative overflow-hidden"      v-bind:space="space"
      v-bind:nodes="nodes"
      v-bind:anchors_spaces="anchors_spaces"
      v-bind:anchors="anchors"
      v-bind:hobjects="hobjects"
      v-bind:nodePidHobjectNameDictionary="nodePidHobjectNameDictionary"
      v-bind:spacePidNameDictionary="spacePidNameDictionary"
      v-bind:geolocatedSpacePidDictionary="geolocatedSpacePidDictionary"
      @sequences-changed="onSequencesChanged"
    ></sequencing>
  </div>
</template>

<script>
import Sequencing from '@/views/hoverlay/pages/sequencing/Sequencing.vue'
import SequencingNavbar from '@/views/hoverlay/pages/sequencing/SequencingNavbar.vue'

export default {
  data() {
    return {
      layer_name: JSON.parse(localStorage.getItem('layerInfo')).name,
      isDirty: false,
    }
  },
  components: {
    Sequencing,
    SequencingNavbar
  },
  watch: {},
  computed: {
    space_pid: function() {
      return this.$route.params.pid
    },
    space() {
      if (this.$store.state.hoverlay) {
        return this.$store.state.hoverlay.spaces.find(space => space.pid == this.space_pid)
      } else return null
    },
    spaces() {
      if (this.$store.state.hoverlay) {
        return this.$store.state.hoverlay.spaces
      } else return null
    },
    nodes() {
      if (this.$store.state.hoverlay) {
        return this.$store.state.hoverlay.nodes.filter(node => node.space_pid == this.space_pid)
      } else return null
    },
    anchors_spaces() {
      if (this.$store.state.hoverlay) {
        return this.$store.state.hoverlay.anchors_spaces
      } else return null
    },
    anchors() {
      var anchoractions = []
      this.nodes.forEach(node => {
        var tmpAnchor = this.$store.state.hoverlay.anchors.find(anchor => anchor.pid == node.anchor_pid)
        if (tmpAnchor && anchoractions.find(anchor => anchor.pid == tmpAnchor.pid) == undefined)
          anchoractions.push(tmpAnchor)
      })
      return anchoractions
    },
    hobjects() {
      var h = []
      this.nodes.forEach(node => {
        var tmp = this.$store.state.hoverlay.hobjects.find(hobject => hobject.pid == node.hobject_pid)
        if (tmp) h.push(tmp)
      })
      return h
    },
    nodePidHobjectNameDictionary() {
      var d = {}
      this.nodes.forEach(node => {
        var tmp = this.$store.state.hoverlay.hobjects.find(hobject => hobject.pid == node.hobject_pid)
        if (tmp) d[node.pid] = node.name
      })
      return d
    },
    spacePidNameDictionary() {
      var d = {}
      this.spaces.forEach(space => {
        d[space.pid] = space.name
      })
      return d
    },
    geolocatedSpacePidDictionary() {
      var d = {}
      this.spaces.forEach(space => {
        if (space.access_level === 'everyone') d[space.pid] = space.name
      })
      return d
    },
    models() {
      if (this.$store.state.hoverlay) {
        return this.$store.state.hoverlay.models
      } else return null
    },
  },
  mounted() {},
  created() {
    this.getSpaceContent()
  },
  methods: {
    async getSpaceContent() {
      this.$vs.loading()
      var params = {
        layer_name: this.layer_name,
        pid: this.$route.params.pid,
      }
      await this.$store.dispatch('hoverlay/getSpaceContent', params)
      this.$vs.loading.close()
    },
    confirmExitWithoutSave(next) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Save changes before closing?',
        text: "Your changes will be lost if you don't save them.",
        acceptText: 'Save',
        cancelText: "Don't save",
        accept: () => this.updateSpaceAndNodes(next),
        cancel: () => this.blockRoute(next),
      })
    },
    async saveSequence(next) {
      await this.$refs.sequencingComponent.updateSpace();
      this.isDirty = false; // Reset dirty state after saving
      next(true)
    },
    blockRoute(next) {
      this.nodes.forEach(node => {
        node.is_dirty = false
      })
      this.isDirty = false; // Reset dirty state when blocking route
      next(true)
    },
    onSequencesChanged() {
      // Mark as dirty when sequences are changed
      this.isDirty = true;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      this.confirmExitWithoutSave(next)
    } else {
      next(true)
    }
  },
}
</script>

<style lang="scss"></style>
